Vue.component('libtrend', {
    props: {
        featured: {
            type: Array
        },
    },
    data () {
        return {
            ncesid: "0803360",
            data: [],
            sortedData: [],
            forecast: [],
            isloaded: false,
            reachZero: false,
            datapoints: false,
            dataformat: false,
            hastable: false,
            title: false
        }
    },
    async created () {
        if (this.featured[0]) {
            this.ncesid = this.featured[0];
        }

        let obj = new FormData;
        obj.append('action', 'slide_get_search_data');
        let params = '{"filters":{"nces_id":["' + this.ncesid + '"],"data_field_id":[20]},"fields":{},"years":"ALL"}';
        obj.append('params', params)
        
        let data = await axios.post(axios_ajax.ajaxurl, obj);
        this.data = data.data;
        let d = data.data;
        let a = []
        for (let i = 0; i < d.length; i++) {
            let o = {}
            let activeYear = d[i].data_year.substring(0, 4)*1;
            o.date = activeYear + '-01-01';
            o.value = d[i].data_value*1;
            a.push(o);
        }
        d = a;
        this.data = d;
        
        // GENERATE SORTED
        let order = Object.keys(d).sort( function (keyA, keyB) {
            if(d[keyB].date < d[keyA].date) {return 1; }
            else {return -1;}                        
        });
        let newObj = [];
        order.forEach(item => {
            let o = {};
            let activeYear = d[item].date.substring(0, 4)*1;
            o.date = activeYear + '-01-01';
            o.value = d[item].value*1;
            newObj.push(o);
        });        
        this.sortedData = newObj;
        

        // GENERATE EMPTY FORECAST
        let lastdata = this.sortedData[this.sortedData.length - 1].value*1;
        let lastyear = this.sortedData[this.sortedData.length - 1].date.substr(0, 4) * 1;
        
        for (let i = 1; i < 11; i++) {
            let nextYear = lastyear + i;
            let o = {date: nextYear + '-01-01'};
            this.forecast.push(o);
        }

        const parseTime = d3.timeParse('%Y-%m-%d');
        const getYear = d3.timeFormat("%Y");
        this.sortedData = this.sortedData.map((d) => {
            return {
                date: parseTime(d.date),
                value: d.value
            }
        })    

        //this.sortedData = [this.sortedData];
        
        const predict = (data, newX) => {
            if (lastdata == 0) {return 0;} 
            const round = n => Math.round(n * 100) / 100;
            
            const sum = data.reduce((acc, pair) => {
              const x = pair[0];
              const y = pair[1];
              
              if (y !== null) {
                acc.x += x;
                acc.y += y;
                acc.squareX += x * x;
                acc.product += x * y;
                acc.len += 1;
              }
              
              return acc;
            }, { x: 0, y: 0, squareX: 0, product: 0, len: 0 });
            const run = ((sum.len * sum.squareX) - (sum.x * sum.x));
            const rise = ((sum.len * sum.product) - (sum.x * sum.y));
            const gradient = run === 0 ? 0 : round(rise / run);
            const intercept = round((sum.y / sum.len) - ((gradient * sum.x) / sum.len));
            return round((gradient * newX) + intercept);
          };

          const dataIndex = this.sortedData.map((d, i) => [i, d.value]);

          
          this.forecast = this.forecast.map((d, i) => {
            return {
              date: parseTime(d.date),
              value: predict(dataIndex, dataIndex.length - 1 + i),
            }
          });
          this.forecast.unshift(this.sortedData[this.sortedData.length - 1]);
        
          let zeroReached = false;
          for (let i = 0; i < this.forecast.length; i++) {
              if (this.forecast[i].value <= 0) {
                    if (!zeroReached) {
                        zeroReached = true;
                        this.forecast[i].value = 0;
                        this.reachZero = getYear(this.forecast[i].date);
                        this.forecast.splice(i+1);
                        break;
                        
                    }
                    
              }
          }
          if (lastdata == 0) {this.reachZero = false;}

          this.isloaded = true

    },
    computed: {
        /*
        sortedData () {
          console.log("🚀 ~ file: libtrend.js ~ line 111 ~ created ~ this.sortedData[this.sortedData.length - 1]", this.sortedData[this.sortedData.length - 1])
          console.log("🚀 ~ file: libtrend.js ~ line 111 ~ created ~ this.sortedData[this.sortedData.length - 1]", this.sortedData[this.sortedData.length - 1])
          console.log("🚀 ~ file: libtrend.js ~ line 111 ~ created ~ this.sortedData[this.sortedData.length - 1]", this.sortedData[this.sortedData.length - 1])
          console.log("🚀 ~ file: libtrend.js ~ line 111 ~ created ~ this.sortedData[this.sortedData.length - 1]", this.sortedData[this.sortedData.length - 1])
            let self = this;
            order = Object.keys(self.data).sort( function (keyA, keyB) {
                if(self.data[keyB].data_year < self.data[keyA].data_year) {return 1; }
                else {return -1;}                        
            });
            let newObj = [];
            order.forEach(item => {
                let o = {};
                let activeYear = self.data[item].data_year.substring(0, 4)*1;
                o.date = activeYear + '-01-01';
                o.value = self.data[item].data_value*1;
                newObj.push(o);
            });             
            return newObj;
        },   
        */         
    }
});